import type { Motivation } from '../types/content'

export const motivations: Motivation[] = [
  {
    id: 'per-te',
    label: 'Per te',
    title: 'Un momento per te',
    description:
      'Scegli un progetto, prepara i tuoi materiali e ritagliati uno spazio per creare con calma.',
    benefits: [
      'Un’attività da vivere con calma',
      'Progetti da scegliere in base al tuo livello',
      'Il piacere di creare con le tue mani',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/8iMS4Pv7mh53CgFSCTynaq/per_te.png',
    imageAlt:
      'Mani che modellano un cuore in cordoncino lilla su un tavolo di legno, accanto a gomitoli pastello, un tricotin a manovella rosa, filo metallico, pinze e forbici',
  },
  {
    id: 'per-decorare',
    label: 'Per decorare',
    title: 'Decorazioni che ti somigliano',
    description:
      'Gioca con forme, iniziali e colori per aggiungere un dettaglio personale ai tuoi spazi.',
    benefits: [
      'Iniziali e nomi da personalizzare',
      'Forme e colori scelti da te',
      'Piccoli dettagli per i tuoi spazi',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/s1yuU5HasM1Sf1BaoAh7k4/per_decorare.png',
    imageAlt:
      'Mensola in legno con libri pastello, una lettera E lilla in tricotin e un vaso con tulipani e fiori in cordoncino rosa, lilla e giallo',
  },
  {
    id: 'per-regalare',
    label: 'Per regalare',
    title: 'Regali fatti con amore',
    description:
      'Trasforma un’idea in un piccolo pensiero da dedicare a qualcuno di speciale.',
    benefits: [
      'Un pensiero creato a mano',
      'Colori scelti per chi lo riceve',
      'Idee per occasioni da ricordare',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/o5t7it54EVEqw3FeJ5J2qC/per_regalare.png',
    imageAlt:
      'Mani che chiudono con un nastro lilla una scatola regalo decorata con una lettera M e un fiore in tricotin, accanto a una farfalla in cordoncino in una scatola e a un sacchetto di organza rosa',
  },
]
